import { configureStore } from '@reduxjs/toolkit';

import productReducer, {
  productDetailReducer,
  productListReducer,
} from './reducers/productReducer';

import { cartReducer } from './reducers/cartReducer';

import {
  userRegisterReducer,
  userSigninReducer,
  userDetailsReducer,
} from './reducers/userReducerOld';

import {
  orderCreateReducer,
  orderDetailsReducer,
  orderMineListReducer,
  orderPayReducer,
  quoteReducer,
} from './reducers/orderReducer';
import { userUpdateProfileReducer } from './reducers/userReducerOld';

// 1. DEFINICIÓN DE THROTTLE (Debe ir arriba para que esté disponible)
const throttle = (func: (...args: any[]) => void, limit: number) => {
  let waiting = false;
  return (...args: any[]) => {
    if (!waiting) {
      func(...args);
      waiting = true;
      setTimeout(() => {
        waiting = false;
      }, limit);
    }
  };
};

//  *** Tipo de estado persistido  ************************************************************* //

interface UserInfo {
  _id: string;
  name: string;
  email: string;
  token: string;
  isAdmin?: boolean;
  // ? agrega los campor reales de tu userInfo
}

interface CartItem {
  product: number;
  name: string;
  image: string;
  price: number;
  countInStock: number;
  qty: number;
  // ! agrega los campos reales de tu cartItem
}

interface ShippingAddress {
  fullName?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  // ! agrega los campos reales de tu shippingAddress
}

// ** Carga inicial desde localStorage  ************************************************************* //

const loadsState = () => {
  try {
    const userInfo: UserInfo | null = localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo')!)
      : null;

    const cartItems: CartItem[] = localStorage.getItem('cartItems')
      ? JSON.parse(localStorage.getItem('cartItems')!)
      : [];

    const shippingAddress: ShippingAddress = localStorage.getItem(
      'shippingAddress'
    )
      ? JSON.parse(localStorage.getItem('shippingAddress')!)
      : {};

    const payMethod: string = localStorage.getItem('payMethod') ?? 'PayPal';

    return {
      userSignin: { userInfo },
      cart: { cartItems, shippingAddress, payMethod },
    };
  } catch (error) {
    console.error('Error loading state from localStorage:', error);
    return undefined;
  }
};

// *** Store ************************************************************* //

const store = configureStore({
  reducer: {
    productList: productListReducer,
    productDetails: productDetailReducer,
    product: productReducer,
    cart: cartReducer,
    userSignin: userSigninReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,
    orderCreate: orderCreateReducer,
    orderDetails: orderDetailsReducer,
    orderMineList: orderMineListReducer,
    orderPay: orderPayReducer,
    orderQuote: quoteReducer,
  },
  preloadedState: loadsState(), // ✅ ahora sí se usa loadState
  devTools: process.env.NODE_ENV !== 'production',
});

// ** Persistencia en localStorage  ************************************************************* //

// store.subscribe(() => {
//   try {
//     const state = store.getState();
//     localStorage.setItem('userInfo', JSON.stringify(state.userSignin.userInfo));
//     localStorage.setItem('cartItems', JSON.stringify(state.cart.cartItems));
//     localStorage.setItem(
//       'shippingAddress',
//       JSON.stringify(state.cart.shippingAddress)
//     );
//   } catch (error) {
//     console.error('Error saving state to localStorage:', error);
//   }
// });

// explicamos que el throttle limita la frecuencia de guardado a una vez cada 1000ms (1 segundo) para evitar problemas de rendimiento al guardar en localStorage con cada cambio de estado

// Función de utilidad para limitar la frecuencia de ejecución
//? const throttle = (func: (...args: any[]) => void, limit: number) => {
// ?  let waiting = false;
// ?  return (...args: any[]) => {
// ?    if (!waiting) {
// ?      func(...args);
// ?      waiting = true;
// ?      setTimeout(() => {
// ?        waiting = false;
// ?      }, limit);
// ?    }
// ?  };
//? };

const saveState = () => {
  try {
    const state = store.getState();
    // Solo guardamos si hay datos, evitando procesos innecesarios
    if ((state.userSignin as any).userInfo) {
      localStorage.setItem(
        'userInfo',
        JSON.stringify((state.userSignin as any).userInfo)
      );
    }

    if ((state as any).cart.cartItems) {
      localStorage.setItem('cartItems', JSON.stringify((state as any).cart.cartItems));
    }

    if ((state as any).cart.shippingAddress) {
      localStorage.setItem(
        'shippingAddress',
        JSON.stringify((state as any).cart.shippingAddress)
      );
    }
  } catch (error) {
    console.error('Error saving state to localStorage:', error);
  }
};
// Aplicamos throttle al subscribe
store.subscribe(throttle(saveState, 1000));

// ** Tipos exportados ( RootState y AppDispatch ) ************************************************************* //

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
